import { type FC } from 'react';
import {
  UiStack,
  uiStyles,
  UiText,
  UiBox,
  type UiStackProps,
  UiHStack,
  UiInput
} from '@/lib/ui';

export interface FieldDateProps extends UiStackProps {
  label: string
  type: string
  onClick: () => void
  isRequired?: boolean
}

const FieldDate: FC<FieldDateProps> = ({
  label,
  onClick,
  isRequired = false,
  ...props
}) => {
  return (
    <UiStack
      borderRadius={uiStyles.borderRadius}
      spacing={2}
      onClick={onClick}
      {...uiStyles.hover}
      {...props}
    >
      <UiHStack justifyContent={'space-between'}>
        <UiText color={'text.secondary'}>{label}{isRequired ? ' *' : ''}</UiText>
        {/* <UiIconPencilSimple size={'2xl'} color={'primary.400'}/> */}
      </UiHStack>
      <UiInput
        bgColor={'indigo.50'}
        placeholder='dd/mm/yyyy'
        cursor="auto"
        isReadOnly
        borderRadius={uiStyles.formElementBorderRadius}
        borderWidth={'1px'}
        borderStyle={'solid'}
        borderColor={'gray.400'}
        height={'40px'}
      />
    </UiStack>
  );
};

export default FieldDate;
